import { store } from 'providers/redux'
import { abilityBuilder } from './abilityBuilder'

export const getAbility = () => {
  const { user } = store.getState().user

  return abilityBuilder(user)
}
